import {useCallback} from 'react';
import {useChatSessions} from './useChatSessions';

const selectChatSessions = state => state.chat.indexed;

export function useEventChatSessions(eventId) {
    const sessionsFilter = useCallback(s => s.eventId == eventId, [eventId]),
        eventSessions = useChatSessions({
            filter: sessionsFilter,
        });

    return eventSessions;
}
